import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormViewSet } from '@cer/cer-form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';

import { WarehouseOutboundOrderService, orderPanes } from '../warehousing/warehouse-outbound-order.service';

export class WarehouseOutboundOrderForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet): void {
    const svc = this.context.injector.get(WarehouseOutboundOrderService);

    viewSet.panes = orderPanes;

    const outboundOrderView = this.outboundOrderViewGet(svc);
    if (viewSet.routeOptions.navigation != null) {
      outboundOrderView.viewMetadata.parentPrimaryKey = null;
    }

    const outboundOrderLineView = this.outboundOrderLineViewGet(svc);

    const params = this.routeOptions.routeParams ?? [];
    outboundOrderView.viewMetadata.dataApiParams = params;
    outboundOrderView.mandatory = true;
    if (!this.isDeliveredVisible(params)) {
      outboundOrderView.fieldMetadata.filter(f => f.name == 'trackTrace').forEach(f => { f.visible = false; });
      outboundOrderLineView.fieldMetadata.filter(f => f.name == 'trackTrace').forEach(f => { f.visible = false; });
    }

    viewSet.viewAdd(outboundOrderView);

    outboundOrderLineView.paneTarget = 'bottom';
    outboundOrderLineView.mandatory = true;
    viewSet.viewAdd(outboundOrderLineView, outboundOrderView);

    const dataNoteView = this.dataNoteViewGet(svc);
    dataNoteView.paneTarget = 'bottomRight';
    dataNoteView.mandatory = true;
    viewSet.viewAdd(dataNoteView, outboundOrderView);
  }

  private outboundOrderViewGet(svc: WarehouseOutboundOrderService): CerFormView {
    const v = new CerFormView({
      viewMetadata: { ...svc.orderViewMetadata },
      toolbarCommands: svc.orderToolbarCommands,
      contextMenuCommands: svc.orderContextMenuCommands,
      onCommandEvent: (e => svc.onCommand(e)),
      fieldMetadata: [...svc.orderFieldMetadata],
      fieldGroupMetadata: svc.orderFieldGroupMetadata,
    });
    v.fieldMetadata.filter(f => f.name == 'status').forEach(f => { f.orderBy = 'Ascending'; f.orderByPriority = 1; });
    v.fieldMetadata.filter(f => f.name == 'created').forEach(f => { f.orderBy = 'Descending'; f.orderByPriority = 2; });
    v.fieldMetadata.filter(f => f.name == 'num').forEach(f => { f.orderBy = 'Descending'; f.orderByPriority = 3; });
    v.fieldMetadata.filter(f => f.name == 'salesOrder').forEach(f => { f.visible = true });
    return v;
  }

  private outboundOrderLineViewGet(svc: WarehouseOutboundOrderService): CerFormView {
    return new CerFormView({
      viewMetadata: { ...svc.orderLineViewMetadata },
      fieldMetadata: [...svc.orderLineFieldMetadata]
    });
  }

  private dataNoteViewGet(svc: WarehouseOutboundOrderService): CerFormView {
    return new CerFormView({
      viewMetadata: svc.dataNoteViewMetadata,
      fieldMetadata: svc.dataNoteFieldMetadata
    });
  }

  private isDeliveredVisible(params: string[]): boolean {
    const isDraft = params.includes("$statusGroup=Draft");
    const isReleased = params.includes("$statusGroup=Released");
    const isRemain = params.includes("$statusGroup=Remain");
    //const isDelivered = params.includes("$statusGroup=Delivered");
    const isDeliveredVisible = !isDraft && !isReleased && !isRemain;
    return isDeliveredVisible;
  }
}
